import script from "./indexDoc.vue?vue&type=script&setup=true&lang=ts"
export * from "./indexDoc.vue?vue&type=script&setup=true&lang=ts"

import "./indexDoc.vue?vue&type=style&index=0&id=06364950&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06364950"]])

export default __exports__